import { useCallback } from 'react';
import { CommonActions } from '@react-navigation/native';
import {
  HOME_TAB_ROUTE_NAME,
  TAB_HOST_ROUTE_NAME,
  useRootStackNavigation,
} from '../../../../hooks/useRootNavigation';
import { bridge } from '../../../bridge';
import { isWeb } from '../../../isWeb';

/** 상품 랭킹 탭(홈 안의 상단탭)으로 이동 */
export const useMoveToRankingGoods = () => {
  const navigation = useRootStackNavigation();

  return useCallback(() => {
    if (isWeb) {
      // 상단탭은 하단탭 호스트 안쪽 라우트라 중첩 형태로 보낸다 (useMoveToHome 참고).
      // selected 는 HomeContents 가 탭 id/screen_name 으로 매칭한다.
      navigation.dispatch(
        CommonActions.navigate(TAB_HOST_ROUTE_NAME, {
          screen: HOME_TAB_ROUTE_NAME,
          params: { selected: 'ranking' },
        }),
      );
      return;
    }

    // openDeeplink 는 웹 라우트가 없는 이 경로에서 앱 다운로드 모달로 흐른다.
    bridge.openPath('/ranking/goods');
  }, [navigation]);
};
